export const UoUStatuses = [
    'Void',
    'Paid',
    'Overdue',
    'PartiallyPaid',
    'PartialAndOverdue',
];
export const isStatusDisplayed = ({ status, isUoU }) => !isUoU || UoUStatuses.includes(status);
//# sourceMappingURL=status-utils.js.map